module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addReason($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Reasons\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.reasons), function(reason) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(reason.title))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editReason(reason)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Reason")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editReason(reason)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Reason")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteReason(reason)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Reason")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete reason "), (_vm.reasonForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.reasonForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteReason(_vm.reasonForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "reasonModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.reason._id) ? _c('span', [_vm._v("Edit Reason")]) : _c('span', [_vm._v("Add Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Reason")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason.title),
      expression: "reason.title"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.reason.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason.title = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveReason
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Reason\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Reason\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a783cf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Reasons.vue
// module id = 739
// module chunks = 1